import { useForm } from 'react-hook-form';
import { CheckIcon } from '@heroicons/react/solid';
import CheckBoxRow from '../parts/CheckBoxRow';
import NitroButton from '../parts/NitroButton';
import $ from 'jquery';

const Checkboxes = ({qData, nextStep}) => {

/**
 * Build data object to be submitted from the checkbox status in DOM
 * Then pass to nextStep function
 */
  function handleSubmit() {

    var checkboxValues = [];
    $('input:checkbox').each( function(){
      if ($(this).is(":checked")){
        var id = this.value;
        var text = $(this).parent().parent().find('.font-black').html();
        checkboxValues.push([{ id: id, langcode: qData.langcode, text: text }]);
      }
    })
    var response = {
      'questionId':qData.id,
      'checkboxValues': checkboxValues
    };

    nextStep(response);
  }
  const { register, watch, formState: { isValid, errors } } = useForm({
    mode: 'onChange',
    defaultValues: {}
  });
  const validationOptions = {};
  if (qData.required) {
    validationOptions.required = 'This field is required';
  }
  if (qData.min_length) {
    validationOptions.validate = (v) => {
      return v.length > qData.min_length-1 || "Select at least " + qData.min_length;
    }
  }

  let checkBoxHtml;

  if (qData.categories.length > 0) {
    // grid of categories
    checkBoxHtml = qData.categories.map((category, index) =>

      <div className="md:flex items-end mb-12 md:mb-6 nitro-cat-row" key={index}>
        <div className="grow md:shrink-0 md:w-1/4">
          <p>{category.text}</p>
        </div>
        <div className="flex mt-2 md:mt-0 md:w-3/4">
          <CheckBoxRow register={register} answers={qData.options} validationOptions={validationOptions} rowName={`groupId-${index}`} />
        </div>
      </div>

    );

  } else {
    // simple list
    checkBoxHtml = qData.options.map((answer, index) =>
      <div key={index} className="mt-3">
        <label htmlFor={"check-box-" + index} className="cursor-pointer flex">
          <div className="shrink-0 relative">
            <input
              {...register("nitroCheckboxes", validationOptions)}
              id={"check-box-" + index}
              value={answer.id}
              type="checkbox"
              className="nitro-checkbox w-6 h-6 md:w-12 md:h-12 appearance-none bg-white checked:bg-white"
            />
            <CheckIcon className="nitro-check-icon text-nitro-slate h-10 w-10 md:w-20 md:h-20 absolute text-opacity-0 transition" />
          </div>
          <div className="ml-4 md:mt-2 text-base md:text-3xl font-black">{answer.text}</div>
        </label>
      </div>
    );

  }

  const overallWidthClass = (qData.categories.length > 0) ? 'max-w-xl' : 'max-w-lg';

  return (
    <>
      <div className="grow py-12">
        <div className={`container ${overallWidthClass}`}>
          <form>
            {checkBoxHtml}
            <input
              type="hidden"
              id={qData.id}
              value={qData.id}
              {...register('questionId')}
            />
            <p className="text-xs">{errors.nitroCheckboxes?.message}</p>
          </form>
        </div>
      </div>
      <NitroButton formIsValid={isValid} label="Next" onClick={handleSubmit} />
    </>
  );
}

export default Checkboxes;
